/* eslint-disable */

import * as runtime from '../runtime';
import type {
  FormDto,
  FormOnFileDto,
  SaveFormResponseDto,
  SavedFormResponseDto,
} from '../models';

export interface GetFormsPublicRequest {
  orgId: number;
  formIds: string;
}

export interface GetFormsOnFileRequest {
  orgId: number;
  formIds: string;
}

export interface SaveResponseRequest {
  id: number;
  orgId: number;
  saveFormResponseDto: SaveFormResponseDto;
}

export interface SaveResponseAnonymousRequest {
  id: number;
  orgId: number;
  saveFormResponseDto: SaveFormResponseDto;
}

export class FormApi extends runtime.BaseAPI {

  async getFormsPublic(requestParameters: GetFormsPublicRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FormDto>> {
    const queryParameters: any = {};

    if (requestParameters.formIds !== undefined) {
      queryParameters['formIds'] = requestParameters.formIds;
    }

    const response = await this.request({
      path: `/form/${encodeURIComponent(String(requestParameters.orgId))}/forms`,
      method: 'GET',
      headers: {},
      query: queryParameters,
    }, initOverrides);
    return response.json();
  }

  async getFormsOnFile(requestParameters: GetFormsOnFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FormOnFileDto>> {
    const queryParameters: any = {};

    if (requestParameters.formIds !== undefined) {
      queryParameters['formIds'] = requestParameters.formIds;
    }

    const response = await this.request({
      path: `/form/${encodeURIComponent(String(requestParameters.orgId))}/forms-on-file`,
      method: 'GET',
      headers: {},
      query: queryParameters,
    }, initOverrides);
    return response.json();
  }

  async saveResponse(requestParameters: SaveResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SavedFormResponseDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/form/${encodeURIComponent(String(requestParameters.orgId))}/${encodeURIComponent(String(requestParameters.id))}/responses`,
      method: 'PUT',
      headers: headerParameters,
      query: {},
      body: requestParameters.saveFormResponseDto,
    }, initOverrides);
    return response.json();
  }

  async saveResponseAnonymous(requestParameters: SaveResponseAnonymousRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SavedFormResponseDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/form/${encodeURIComponent(String(requestParameters.orgId))}/${encodeURIComponent(String(requestParameters.id))}/responses-anonymous`,
      method: 'PUT',
      headers: headerParameters,
      query: {},
      body: requestParameters.saveFormResponseDto,
    }, initOverrides);
    return response.json();
  }

}
